const handleServerAction = async (action: Function, payload?: any) => {
  const response = await action(payload);
  if (response && response.error) {
    throw new Error(response.error);
  }
  return response;
};

export default handleServerAction;
